import type { ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

import { VoiceIcon, type VoiceIconName } from './icon'

export type BtnVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type BtnSize = 'sm' | 'md' | 'lg'

interface BtnProps {
  children?: ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  variant?: BtnVariant
  icon?: VoiceIconName
  size?: BtnSize
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit'
}

const VARIANT_CLASSES: Record<BtnVariant, string> = {
  primary: 'bg-white text-[#1a1a1a] border border-white',
  secondary: 'bg-white/[0.08] text-[var(--text-1)] border border-[var(--border-strong)]',
  ghost: 'bg-white/[0.03] text-[var(--text-2)] border border-[var(--border)]',
  danger: 'bg-[rgba(239,68,68,0.08)] text-[#fca5a5] border border-[rgba(239,68,68,0.20)]',
}

const SIZE_CLASSES: Record<BtnSize, string> = {
  sm: 'px-[10px] py-[6px] text-xs rounded-lg gap-1.5',
  md: 'px-4 py-2.5 text-[13px] rounded-[10px] gap-2',
  lg: 'px-[22px] py-[14px] text-sm rounded-xl gap-2.5',
}

/**
 * Voice 模块通用按钮（4 种 variant × 3 种 size）
 */
export const Btn = ({
  children,
  onClick,
  variant = 'ghost',
  icon,
  size = 'md',
  className,
  disabled,
  type = 'button',
}: BtnProps) => {
  return (
    <button
      disabled={disabled}
      type={type}
      className={cn(
        'inline-flex items-center font-medium transition-all duration-200 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className
      )}
      onClick={onClick}
    >
      {icon && <VoiceIcon name={icon} size={size === 'sm' ? 12 : size === 'lg' ? 16 : 14} />}
      {children}
    </button>
  )
}
